export const BREAKPOINTS = {
  mobile: '(max-width: 576px)',
  tablet: '(max-width: 769px)',
};

export const BREAKPOINT_SIZES = {
  xs: 363,
  sm: 576,
  md: 769,
  lg: 1192,
};
